import {
  SkeletonProfileImage,
  SkeletonHeadline,
  SkeletonBody,
} from '@xing-com/skeleton';

import * as Styled from './company-recommendation-card.styles';

export const CompanyRecommendationCardSkeleton: React.FC = () => (
  <Styled.Card>
    <Styled.ProfileBackground>
      <Styled.SkeletonProfileImage>
        <SkeletonProfileImage size="large" />
      </Styled.SkeletonProfileImage>
    </Styled.ProfileBackground>
    <Styled.SkeletonHeadline>
      <SkeletonHeadline size="medium" amountRows={1} />
    </Styled.SkeletonHeadline>
    {/* @ts-expect-error FIXME: SC6 */}
    <SkeletonBody size="medium" amountRows={2} />
  </Styled.Card>
);
